import React from 'react'
import { Progress } from 'react-sweet-progress'
import 'react-sweet-progress/lib/style.css'

const ProgressBar = ({ title, clr, percentage }) => {
    return (
        <div className="mb-2">
            <h2 className="text-2xl">{title}</h2>
            <Progress
                status="bar"
                theme={{
                    bar: {
                        color: clr
                    }
                }}
                percent={percentage}
            />
        </div>
    )
}

export default ProgressBar
